export default __webpack_public_path__ + "static/23_31-6f5cb46d6f53187ec1ba08d123b43885.png";